// extracted by mini-css-extract-plugin
export var container = "_27-0";